export default {
    EMAIL: 1,
    PHONE: 2
};
